import { createAction } from "redux-actions";
import {
  urlCoberturasAccidente,
  urlCalcularCotizacionAP,
  urlCrearCarritoAP,
  urlAgregarProductoCarritoAP,
  urlRecuperarCarritoAP,
  urlGenerarCotizacionCarritoAP,
  urlEnviarCotizacionCarritoAP,
  urlObtenerPlanesAccP,
  urlCrearCarritoAccP,
  urlProvinciasAP,
  urlCiudadesAP,
  urlCoberturasAccP,
  urlRecuperarCarritoAccP,
  urlProcesoCarritoAccP,
  urlEnviarCotizacionCarritoAccP,
  urlObtenerPlanesAccPAigmed,
  urlGuardarEmisionRetroactiva,
} from "../../constants/urls";

//Listar Limites - Cotizacion Financiero mediate redux-actions
export const listarCoberturasAPIsLoading = createAction(
  "LISTAR_COBERTURASAP_IS_LOADING"
);
export const listarCoberturasAPhasError = createAction(
  "LISTAR_COBERTURASAP_HAS_ERROR"
);
export const setListarCoberturasAP = createAction("SET_LISTAR_COBERTURASAP");

export const listarCoberturasAccPIsLoading = createAction(
  "LISTAR_COBERTURASACCP_IS_LOADING"
);
export const listarCoberturasAccPhasError = createAction(
  "LISTAR_COBERTURASACCP_HAS_ERROR"
);
export const setListarCoberturasAccP = createAction(
  "SET_LISTAR_COBERTURASACCP"
);

//crear carrito para accidentes personales

export const setCrearCarritoTravelGroup = createAction(
  "SET_CREAR_CARRITO_TRAVEL_GROUP"
);
export const crearCarritoTravelGroupError = createAction(
  "CREAR_CARRITO_TRAVEL_GROUP_ERROR"
);
export const crearCarritoTravelGrouploading = createAction(
  "CREAR_CARRITO_TRAVEL_GROUP_LOADING"
);

export const setCrearCarritoAccP = createAction("SET_CREAR_CARRITO_ACC_P");
export const crearCarritoAccPError = createAction("CREAR_CARRITO_ACC_P_ERROR");
export const crearCarritoAccPloading = createAction(
  "CREAR_CARRITO_ACC_P_LOADING"
);

//agregar el producto en el carrito

export const setAgregarProductoCarrito = createAction(
  "SET_AGREGAR_PRODUCTO_CARRITO"
);
export const agregarProductoCarritoError = createAction(
  "AGREGAR_PRODUCTO_CARRITO_ERROR"
);
export const agregarProductoCarritoloading = createAction(
  "AGREGAR_PRODUCTO_CARRITO_LOADING"
);

//Realizar Calculos - Cotizacion Accidentes Personales mediate redux-actions
export const calculoCotizacionAPIsLoading = createAction(
  "CALCULO_COTIZACION_AP_IS_LOADING"
);
export const calculoCotizacionAPhasError = createAction(
  "CALCULO_COTIZACION_AP_HAS_ERROR"
);
export const setCalculoCotizacionAP = createAction("SET_CALCULO_COTIZACION_AP");

//Recuperar carrito - Cotizacion Accidentes Personales mediate redux-actions
export const recuperarCarritoAPIsLoading = createAction(
  "RECUPERAR_CARRITO_AP_IS_LOADING"
);
export const recuperarCarritoAPhasError = createAction(
  "RECUPERAR_CARRITO_AP_HAS_ERROR"
);
export const setRecuperarCarritoAP = createAction("SET_RECUPERAR_CARRITO_AP");

//generar pdf de cotizacion

export const generarCotizacionCarritoAPIsLoading = createAction(
  "GENERAR-COTIZACION-CARRITO-AP-IS-LOADING"
);
export const generarCotizacionAPhasError = createAction(
  "GENERAR-COTIZACION-CARRITO-AP-HAS-ERROR"
);
export const setGenerarCotizacionCarritoAP = createAction(
  "SET-GENERAR-COTIZACION-CARRITO-AP"
);

//enviar pdf de cotizacion

export const enviarCotizacionCarritoAPIsLoading = createAction(
  "ENVIAR-COTIZACION-CARRITO-AP-IS-LOADING"
);
export const enviarCotizacionAPhasError = createAction(
  "ENVIAR-COTIZACION-CARRITO-AP-HAS-ERROR"
);
export const setEnviarCotizacionCarritoAP = createAction(
  "SET-ENVIAR-COTIZACION-CARRITO-AP"
);

//enviar pdf de cotizacion

export const enviarCotizacionCarritoAccPIsLoading = createAction(
  "ENVIAR-COTIZACION-CARRITO-ACCP-IS-LOADING"
);
export const enviarCotizacionAccPhasError = createAction(
  "ENVIAR-COTIZACION-CARRITO-ACCP-HAS-ERROR"
);
export const setEnviarCotizacionCarritoAccP = createAction(
  "SET-ENVIAR-COTIZACION-CARRITO-ACCP"
);

//enviar pdf de cotizacion

export const obtenerPlanesAccPIsLoading = createAction(
  "OBTENER-PLANES-ACCP-IS-LOADING"
);
export const obtenerPlanesAccPhasError = createAction(
  "OBTENER-PLANES-ACCP-HAS-ERROR"
);

export const obtenerPlanesAccPAigmedhasError = createAction(
  "OBTENER-PLANES-ACCP-HAS-ERROR-AIGMED"
);

export const setObtenerPlanesAccP = createAction("SET-OBTENER-PLANES-ACCP");

export const setObtenerPlanesAccPAigmed = createAction("SET-OBTENER-PLANES-ACCP-AIGMED");

//listarProvincias

export const setObtenerProvinciasAP = createAction("SET_OBTENER_PROVINCIAS_AP");
export const obtenerProviciasAPError = createAction(
  "OBTENER_PROVINCIAS_AP_ERROR"
);
export const obtenerProvinciasLoading = createAction(
  "OBTENER_PROVINCIAS_AP_LOADING"
);

//listarCiudades

export const setObtenerCiudadesAP = createAction("SET_OBTENER_CIUDADES_AP");
export const obtenerCiudadesAPError = createAction("OBTENER_CIUDADES_AP_ERROR");
export const obtenerCiudadesLoading = createAction(
  "OBTENER_CIUDADES_AP_LOADING"
);

//Recuperar carrito - Cotizacion Accidentes Personales
export const recuperarCarritoAccPIsLoading = createAction(
  "RECUPERAR_CARRITO_ACCP_IS_LOADING"
);
export const recuperarCarritoAccPhasError = createAction(
  "RECUPERAR_CARRITO_ACCP_HAS_ERROR"
);
export const setRecuperarCarritoAccP = createAction(
  "SET_RECUPERAR_CARRITO_ACCP"
);

//Proceso carrito - Cotizacion Accidentes Personales
export const procesoCarritoAccPIsLoading = createAction(
  "PROCESO_CARRITO_ACCP_IS_LOADING"
);
export const procesoCarritoAccPhasError = createAction(
  "PROCESO_CARRITO_ACCP_HAS_ERROR"
);
export const setProcesoCarritoAccP = createAction("SET_PROCESO_CARRITO_ACCP");

//Coberturas - Cotizacion Accidentes Personales

export const fetchObtenerCoberturasAP = (param) => async (dispatch) => {
  var url = `${urlCoberturasAccidente}`;
  dispatch(listarCoberturasAPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        var coberturasAP = {};
        coberturasAP = data;
        dispatch(setListarCoberturasAP(coberturasAP));
      } else {
        dispatch(listarCoberturasAPhasError());
      }
    })
    .catch(() => {
      dispatch(listarCoberturasAPhasError());
    });
};

//crear carrito para para accidentes personales travel group

export const fetchCrearCarritoAP = (param) => async (dispatch) => {
  var url = `${urlCrearCarritoAP}`;
  dispatch(crearCarritoTravelGrouploading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.creacionCarrito;
      if (transaccion) {
        dispatch(setCrearCarritoTravelGroup(data));
      } else {
        dispatch(crearCarritoTravelGroupError());
      }
    })
    .catch(() => {
      dispatch(crearCarritoTravelGroupError());
    });
};

//agregar productos al carrito de accidentes personales travel group

export const fetchAgregarProductoCarritoAP = (param) => async (dispatch) => {
  var url = `${urlAgregarProductoCarritoAP}`;
  dispatch(agregarProductoCarritoloading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setAgregarProductoCarrito(data));
      } else {
        dispatch(agregarProductoCarritoError());
      }
    })
    .catch(() => {
      dispatch(agregarProductoCarritoError());
    });
};

//Realizar Calculos - Cotizacion Accidentes Personales

export const fetchCalcularCotizacionAP = (param) => async (dispatch) => {
  var url = `${urlCalcularCotizacionAP}`;

  dispatch(calculoCotizacionAPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setCalculoCotizacionAP(data));
      } else {
        dispatch(calculoCotizacionAPhasError());
      }
    })
    .catch(() => {
      dispatch(calculoCotizacionAPhasError());
    });
};

export const fetchGuardarEmisionRetroactiva = (param) => async (dispatch) => {
  var url = `${urlGuardarEmisionRetroactiva}`;

  dispatch(calculoCotizacionAPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
       console.log('data2', data)
      } else {
        dispatch(calculoCotizacionAPhasError());
      }
    })
    .catch(() => {
      dispatch(calculoCotizacionAPhasError());
    });
};

//Recuperar carrito - Cotizacion Accidentes Personales

export const fetchRecuperarCarritoAP = (param) => async (dispatch) => {
  var url = `${urlRecuperarCarritoAP}`;

  dispatch(recuperarCarritoAPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setRecuperarCarritoAP(data));
      } else {
        dispatch(recuperarCarritoAPhasError());
      }
    })
    .catch(() => {
      dispatch(recuperarCarritoAPhasError());
    });
};

//descargar cotizacion

export const FetchDescargarCotizacion = (param) => async (dispatch) => {
  var url = `${urlGenerarCotizacionCarritoAP}`;

  dispatch(generarCotizacionCarritoAPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setGenerarCotizacionCarritoAP(data));
      } else {
        dispatch(generarCotizacionAPhasError());
      }
    })
    .catch(() => {
      dispatch(generarCotizacionAPhasError());
    });
};

//enviar cotizacion

export const FetchEnviaCotizacion = (param) => async (dispatch) => {
  var url = `${urlEnviarCotizacionCarritoAP}`;

  dispatch(enviarCotizacionCarritoAPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setEnviarCotizacionCarritoAP(data));
      } else {
        dispatch(enviarCotizacionAPhasError());
      }
    })
    .catch(() => {
      dispatch(enviarCotizacionAPhasError());
    });
};

//enviar cotizacion

export const fetchObtenerPlanes = (param) => async (dispatch) => {
  var url = `${urlObtenerPlanesAccP}`;

  dispatch(obtenerPlanesAccPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setObtenerPlanesAccP(data));
      } else {
        dispatch(obtenerPlanesAccPhasError());
      }
    })
    .catch(() => {
      dispatch(obtenerPlanesAccPhasError());
    });
};

export const fetchObtenerPlanesAigmed = () => async (dispatch) => {
  var url = `${urlObtenerPlanesAccPAigmed}`;

  dispatch(obtenerPlanesAccPIsLoading());
  await fetch(url, {
    method: "get",
    headers: {
      Accept: "application/json",
    }
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setObtenerPlanesAccPAigmed(data.coberturas));
      } else {
        dispatch(obtenerPlanesAccPAigmedhasError());
      }
    })
    .catch(() => {
      dispatch(obtenerPlanesAccPAigmedhasError());
    });
};

//crear carrito para para accidentes personales

export const fetchCrearCarritoAccP = (param) => async (dispatch) => {
  var url = `${urlCrearCarritoAccP}`;
  dispatch(crearCarritoAccPloading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setCrearCarritoAccP(data));
      } else {
        dispatch(crearCarritoAccPError());
      }
    })
    .catch(() => {
      dispatch(crearCarritoAccPError());
    });
};

//listar provincias para para accidentes personales

export const fetchListarProvinciasAP = (empresa, ramo) => async (dispatch) => {
  var url = `${urlProvinciasAP}&empresa=${empresa}&ramo=${ramo}`;

  dispatch(obtenerProvinciasLoading());

  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        var provincias = [];
        provincias = data.provinciaFormato;

        dispatch(setObtenerProvinciasAP(provincias));
      } else {
        dispatch(obtenerProviciasAPError());
      }
    })
    .catch(() => {
      dispatch(obtenerProviciasAPError());
    });
};

//listar provincias para para accidentes personales

export const fetchListarCiudadesAP = (param) => async (dispatch) => {
  var url = `${urlCiudadesAP}`;
  dispatch(obtenerCiudadesLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setObtenerCiudadesAP(data));
      } else {
        dispatch(obtenerCiudadesAPError());
      }
    })
    .catch(() => {
      dispatch(obtenerCiudadesAPError());
    });
};

//Coberturas - Cotizacion Accidentes Personales

export const fetchObtenerCoberturasAccP = (param) => async (dispatch) => {
  var url = `${urlCoberturasAccP}`;
  dispatch(listarCoberturasAccPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (!transaccion) {
        var coberturasAP = [];
        coberturasAP = data;
        dispatch(setListarCoberturasAccP(coberturasAP));
      } else {
        dispatch(listarCoberturasAccPhasError());
      }
    })
    .catch(() => {
      dispatch(listarCoberturasAccPhasError());
    });
};

//Recuperar carrito - Cotizacion Accidentes Personales

export const fetchRecuperarCarritoAccP = (param) => async (dispatch) => {
  var url = `${urlRecuperarCarritoAccP}`;

  dispatch(recuperarCarritoAccPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setRecuperarCarritoAccP(data));
      } else {
        dispatch(recuperarCarritoAccPhasError());
      }
    })
    .catch(() => {
      dispatch(recuperarCarritoAccPhasError());
    });
};


//Recuperar carrito - Cotizacion Accidentes Personales

export const fetchProcesoCarritoAccP = (param) => async (dispatch) => {
  var url = `${urlProcesoCarritoAccP}`;

  dispatch(procesoCarritoAccPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setProcesoCarritoAccP(data));
      } else {
        dispatch(procesoCarritoAccPhasError());
      }
    })
    .catch(() => {
      dispatch(procesoCarritoAccPhasError());
    });
};
export const fetchUpdateProcesoCarritoAccP = (param) => async (dispatch) => {
  

  var url = `${urlRecuperarCarritoAccP}`;
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setProcesoCarritoAccP(data));
      }
    })
    .catch(() => {
   
    });
};

//enviar cotizacion

export const FetchEnviaCotizacionAccP = (param) => async (dispatch) => {
  var url = `${urlEnviarCotizacionCarritoAccP}`;

  dispatch(enviarCotizacionCarritoAccPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;

      if (transaccion) {
        dispatch(setEnviarCotizacionCarritoAccP(data));
      } else {
        dispatch(enviarCotizacionAccPhasError());
      }
    })
    .catch(() => {
      dispatch(enviarCotizacionAccPhasError());
    });
};
